module.exports = __webpack_public_path__ + "img/icone-menu.8086623c.svg";